import React from "react";
import { AuthContext } from "context/auth";

const useAuth = () => React.useContext(AuthContext);

export default useAuth;
